import { simplePayment, loanPaydown } from "@/js/model/Functions";
import { Model } from "@/js/model/Model";
import { FixedSeries } from "@/js/model/DataSeries";

const _ = require('lodash');


let modelClosedLoan = new Model('Closed End Loan');

let interest = modelClosedLoan.addComponent('APR');
interest.setData(new FixedSeries(0.03));

let atf = modelClosedLoan.addComponent('Amount Financed');
atf.setData(new FixedSeries(22000));

let term = modelClosedLoan.addComponent('Loan Term');
term.setData(new FixedSeries(72));

modelClosedLoan.addComponentWithMethod('Payment',
  simplePayment,
  {
    apr: 'APR',
    term: 'Loan Term',
    amount: 'Amount Financed'
  }
);

modelClosedLoan.addComponentWithMethod('Balance',
  loanPaydown,
  {
    balance: 'Amount Financed',
    apr: 'APR',
    payment: 'Payment'
  }
);

modelClosedLoan.layout.updateAttributes({
  'dagWidth': 500,
  'dagHeight': 275
});

export const template = {
  'Label': 'Auto Loan Paydown',
  'Category': 'Finance',
  'Description': 'Paydown scenario for a fixed-rate auto loan',
  'model': modelClosedLoan
}